import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { modules_for } from '../apps/registry';
import { IconHome, IconMembers, IconBilling, IconSignOut } from './icons';

const nav_class = ({ isActive }: { isActive: boolean }) => (isActive ? 'nav-link active' : 'nav-link');

export function Layout() {
  const { state, sign_out } = useAuth();
  if (state.status !== 'signed_in') return null; // Shell guarantees this
  const { session, email } = state;
  const modules = modules_for(session.apps);
  const can_manage = session.role !== 'member';
  const initial = (session.first_name || session.tenant_name || '?').trim().charAt(0).toUpperCase();

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <span className="mark">C</span>
          Captomi
        </div>
        <div className="workspace">
          <div className="eyebrow" style={{ marginBottom: 2 }}>Workspace</div>
          <div style={{ fontWeight: 600, fontSize: 14 }}>{session.tenant_name}</div>
        </div>

        <nav>
          <NavLink to="/" end className={nav_class}>
            <IconHome /> Home
          </NavLink>
          {can_manage && (
            <NavLink to="/members" className={nav_class}>
              <IconMembers /> Members
            </NavLink>
          )}
          <NavLink to="/billing" className={nav_class}>
            <IconBilling /> Billing
          </NavLink>

          {modules.length === 0 && (
            <div className="muted" style={{ fontSize: 13, padding: '12px 10px' }}>No apps yet.</div>
          )}

          {modules.map((m) => (
            <div className="nav-section" key={m.app_code}>
              <div className="nav-section-label" style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                <span style={{ color: m.accent ?? 'var(--text-3)', display: 'inline-flex' }}>
                  {m.icon}
                </span>
                {m.label}
              </div>
              {m.nav.map((n) => (
                <NavLink key={n.path} to={`/a/${m.app_code}/${n.path}`} className={nav_class}>
                  {n.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div className="spacer" />
        <div className="user">
          <div className="avatar">{initial}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {session.first_name || 'Account'}
            </div>
            <div className="subtle" style={{ fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {email ?? ''}
            </div>
          </div>
          <button className="btn ghost sm" title="Sign out" onClick={() => void sign_out()} aria-label="Sign out">
            <IconSignOut />
          </button>
        </div>
      </aside>

      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
